/* eslint-disable wc/guard-super-call */
// eslint-disable-next-line max-classes-per-file
import { customElement, property } from 'lit/decorators.js';
import { find } from 'lodash-es';
import { dayjs } from '../../common';
import KiWwpGraph from './ki-wwp-graph';
import { getCurrentApi, initAPI } from '../../api/API';
import {
  getTimeZone,
  initConfig,
} from '../ki-app/services/ki-app-config-service';

@customElement('ki-wwp-graph-ext')
export class KiWwpGraphExt extends KiWwpGraph {
  @property({ type: String })
  key;

  @property({ type: String })
  stationId;

  @property({ type: String })
  dataPath;

  favButton = false;

  connectedCallback() {
    super.connectedCallback();
    this.initAppConfig();
  }

  firstUpdated() {
    this.refreshInterval = setInterval(() => {
      this.fetchData();
    }, 300000);
  }

  async initAppConfig() {
    this.config = await initConfig('./config/app.json', []);
    this.timeZone = getTimeZone();
    initAPI({
      dataPath: this.config.dataPath || this.config.apiPath,
      apiType: this.config.apiType,
    });
    this.api = getCurrentApi();
    this.fetchData();
  }

  async fetchData() {
    dayjs.locale(this.i18n.language);
    const stationDetailComp = this.config.route[0].children.find(child =>
      child?.component?.includes('wwp-station-detail'),
    );
    const configItem = find(stationDetailComp.children, { path: this.key });
    if (configItem) {
      Object.assign(this, configItem.options);
    }
    this._selectedPeriod = this.period;
    this.imageShare = false;
    this.tableOpen = false;
    super.fetchData();
  }
}
